import { render, staticRenderFns } from "./MsInput.vue?vue&type=template&id=33bfec6e&scoped=true"
import script from "./MsInput.vue?vue&type=script&lang=js"
export * from "./MsInput.vue?vue&type=script&lang=js"
import style0 from "./MsInput.vue?vue&type=style&index=0&id=33bfec6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfec6e",
  null
  
)

export default component.exports